export class MenuConstant {



    // Consecutivo de Opciones predefinidas del menu del cotizador
    public static OPCIONES_COTIZADOR_MENU_INICIO = 1;
    public static OPCIONES_COTIZADOR_MENU_SOLUCIONES = 2;
    public static OPCIONES_COTIZADOR_MENU_MIS_NEGOCIOS = 3;
    public static OPCIONES_COTIZADOR_MENU_MIS_CLIENTES = 4;
    // public static OPCIONES_COTIZADOR_MENU_MIS_MAPAS = 5;
    // public static OPCIONES_COTIZADOR_MENU_MAPA_RIESGOS = 6;
    public static OPCIONES_COTIZADOR_MENU_FORMATOS = 5;
    public static OPCIONES_COTIZADOR_MENU_CONTACTO = 6;
    public static OPCIONES_COTIZADOR_MENU_SALIR = 7;

    // Descripcion de las opciones predefinidas del menu cotizador
    public static DS_COTIZADOR_MENU_INICIO = 'Inicio';
    public static DS_COTIZADOR_MENU_SOLUCIONES = 'Soluciones';
    public static DS_COTIZADOR_MENU_MIS_NEGOCIOS = 'Mis Negocios';
    public static DS_COTIZADOR_MENU_MIS_CLIENTES = 'Mis Clientes';
    // public static DS_COTIZADOR_MENU_MIS_MAPAS = 'Mis Mapas';
    // public static DS_COTIZADOR_MENU_MAPA_RIESGOS = 'Mapa de Riesgos';
    public static DS_COTIZADOR_MENU_FORMATOS = 'Formatos';
    public static DS_COTIZADOR_MENU_CONTACTO = 'Contacto';
    public static DS_COTIZADOR_MENU_SALIR = 'Salir';

    // Rutas de los iconos de las opciones principles
    public static RUTA_IMG_MENU_INICIO = 'assets/img/main/ico-inicio.png';
    public static RUTA_IMG_MENU_SOLUCIONES = 'assets/img/main/ico-soliciones.png';
    public static RUTA_IMG_MENU_NEGOCIOS = 'assets/img/main/ico-misNegocios.png';
    public static RUTA_IMG_MENU_MIS_CLIENTES = 'assets/img/main/ico-misClientes.png';
    // public static RUTA_IMG_MENU_MIS_MAPAS = 'assets/img/main/ico-misMapas.png';
    // public static RUTA_IMG_MENU_MAPA_RIESGOS = 'assets/img/main/ico-mapaRiesgos.png';
    public static RUTA_IMG_MENU_FORMATOS = 'assets/img/main/ico-formatos.png';
    public static RUTA_IMG_MENU_CONTACTO = 'assets/img/main/ico-contacto.png';
    public static RUTA_IMG_MENU_SALIR = 'assets/img/main/ico-salir.png';

    // Nombres de las clases con Estilos personalizados por opciones predeterminadas
    public static CLASS_MENU_INICIO = 'inicio';
    public static CLASS_MENU_SOLUCIONES = 'soluciones';
    public static CLASS_MENU_MIS_NEGOCIOS = 'misNegocios';
    public static CLASS_MENU_MIS_CLIENTES = 'misClientes';
    // public static CLASS_MENU_MIS_MAPAS = 'misMapas';
    // public static CLASS_MENU_MAPA_RIESGOS = 'mapaRiesgos';
    public static CLASS_MENU_FORMATOS = 'formatos';
    public static CLASS_MENU_CONTACTO = 'contactos';
    public static CLASS_MENU_SALIR = 'salir';


    // Rutas de las opciones Fijas del menu
    public static RUTA_MENU_INICIO = 'Inicio';

    public static REDIRECCION_MENU_MODIFICACIONES_PVP  = 'ModificacionesVidaPVP';
    public static MENSAJE_MODIFICACIONES_PVP  = 'El proceso de modificaciones por solicitud electrónica, SOLO estará disponible para las pólizas expedidas antes del 9 de Julio, siempre que no hayan seleccionado el tipo de indemnización o incluyan las coberturas de devolución o renta diaria por cualquier causa.';


}



// WEBPACK FOOTER //
// ./src/app/contants/menu.constant.ts